import {
  ManySalesGroupResource,
  SalesGroupAttributes,
  SingleSalesGroupResource,
} from 'api-client'
import * as R from 'ramda'

import { request } from '~shared-components/api/request'
import { ValidatedCustomerModel } from '~shared-components/transforms/user.transforms'
import { deserialize } from '~shared-components/utils/deserialize'

export interface Filters {
  distributionChannels?: string[]
  divisions?: string[]
  ids?: string[]
  salesOrganizations?: string[]
}

interface FetchSalesGroupParams {
  salesGroupId: string
}

export interface SalesGroup extends SalesGroupAttributes {
  customers?: ValidatedCustomerModel[]
  id: string
}

export const fetchSalesGroup = async ({
  salesGroupId,
}: FetchSalesGroupParams) => {
  const response = await request<SingleSalesGroupResource>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `/api/sales-groups/${salesGroupId}`,
  })

  if (response?.data) {
    return deserialize<SalesGroup>(response?.data)
  } else {
    throw new Error('No response from API for Salesgroup')
  }
}

export const fetchSalesGroups = async (
  filters?: Filters,
): Promise<SalesGroup[]> => {
  const getFilter = (key: keyof Filters): string[] =>
    R.pathOr<string[]>([], [key], filters)

  const salesOrganizations = getFilter('salesOrganizations')
  const distributionChannels = getFilter('distributionChannels')
  const divisions = getFilter('divisions')
  const ids = getFilter('ids')

  const query = [
    `${ids.length > 0 ? `filter[id.in]=${ids.join(',')}` : ''}`,
    `${
      salesOrganizations.length > 0
        ? `filter[salesOrganization.in]=${salesOrganizations.join(',')}`
        : ''
    }`,
    `${
      distributionChannels.length > 0
        ? `filter[distributionChannel.in]=${distributionChannels}`
        : ''
    }`,
    `${
      divisions.length > 0 ? `filter[division.in]=${divisions.join(',')}` : ''
    }`,
  ]
    .filter(filter => filter.length > 0)
    .join('&')

  const response = await request<ManySalesGroupResource>({
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'GET',
    url: `/api/sales-groups?page[size]=100&sort=salesOrganization,distributionChannel,name${
      query.length > 0 ? `&${query}` : ''
    }`,
  })

  return deserialize<SalesGroup[]>(response?.data)
}
